export default __webpack_public_path__ + "static/media/Arm-straps of the Sepulcher.4ecf3c6b.jpg";